export enum ChallengeActionType {
  Challenge = 'threeDS2Challenge',
  Fingerprint = 'threeDS2Fingerprint',
  Redirect = 'redirect',
  Paypal = 'paypal',
}
